module.exports = __webpack_public_path__ + "img/pp.e4a4a1e8.png";